import React from 'react'
import packageJson from '../../package.json'

const VersionInfo = () => {
  return (
    <div className="text-center text-muted small py-2">
      v{packageJson.version}
    </div>
  )
}

export default VersionInfo
